export function formatPhoneNumber(s_raw) {
    const s = `${s_raw}`;
    return (s.replaceAll('-','').replaceAll(' ','').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'));
}